<div [formGroup]="plansForm">
  <p-accordion
    [value]="-1"
    class="div-header"
    [expandIcon]="'pi pi-fw pi-chevron-down'"
    [collapseIcon]="'pi pi-fw pi-chevron-up'"
  >
    @for (tab of QboPlansData; track tab.SKU; let i = $index) {
      <!-- eslint-disable-next-line @angular-eslint/template/interactive-supports-focus-->
      <div
        (keyup.enter)="setRow(i)"
        [ngClass]="{
          'div-highlight': selectedIndex === i,
          'qbo-plan':
            existingQboPlans === null ||
            (tab.PackageCategoryName.trim() !== existingQboPlans.Type.trim() &&
              tab.PackageCategoryName.trim() !== 'Simple Start' &&
              isChangeSubType)
        }"
        (click)="setRow(i)"
      >
        @if (
          existingQboPlans === null ||
          (tab.PackageCategoryName.trim() !== existingQboPlans.Type.trim() &&
            tab.PackageCategoryName.trim() !== 'Simple Start' &&
            isChangeSubType)
        ) {
          <p-accordion-panel [value]="i" class="qboAccordionTab" (click)="selectionOccured(tab)">
            <p-accordion-header>
              <span class="package-name">{{ tab.PackageCategoryName }}</span>
              <span class="package-amount">
                <span class="float-right">
                  ${{ tab.NextBillPrice | number: '1.2-2' }}
                  <span class="month-label">/month</span>
                </span>
              </span>
            </p-accordion-header>
            <p-accordion-content>
              <p class="package-content" [innerHtml]="tab.HTMPDescription"></p>
            </p-accordion-content>
          </p-accordion-panel>
        }
      </div>
    }
  </p-accordion>
</div>
